import {apiGet, apiPost, apiPut, apiDelete, apiPatch} from '@/utils/request'

/**
 * 获取创建班级选项
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1147
 * @return Promise
 *
 * @author vince
 */
export function getCreateClassOptions() {
  return apiGet('/class/create_option')
}

/**
 * 创建班级
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1149
 *
 * @param {string} [gradeId] [年级id]
 * @param {string} [classNo] [班级编号]
 * @param {string} [snType] [学号格式类别编号]
 * @param {int} [studentCount] [班级学生数量]
 * @param {int} [roleId] [角色类型]
 * @param {int} [referUser] [推荐人id]
 * @param {string} [source] [创建班级的来源,定义见下方来源]
 * @link [source来源定义] https://shimo.im/docs/C5D5xF9H5Kgn27xh
 * 
 * @return Promise
 * 
 * @author vince
 */
export function createClass(gradeId, classNo, studentCount, roleId, referUser, source, alias) {
  return apiPost('/class/create', {
    grade_id: gradeId,
    class_no: classNo,
    student_count: studentCount,
    role_id: roleId,
    refer_user_id: referUser,
    source: source,
    alias: alias,
  })
}


/**
 * 创建班级
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3653
 *
 * @param {string} [gradeId] [年级id]
 * @param {string} [classNo] [班级编号]
 * @param {string} [snType] [学号格式类别编号]
 * @param {int} [studentCount] [班级学生数量]
 * @param {int} [roleId] [角色类型]
 * @param {int} [referUser] [推荐人id]
 * @param {string} [source] [创建班级的来源,定义见下方来源]
 * @link [source来源定义] https://shimo.im/docs/C5D5xF9H5Kgn27xh
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function createInviteClass(gradeId, classNo, studentCount, roleId, referUser, source, alias) {
  return apiPost('/class/create_invite_class', {
    grade_id: gradeId,
    class_no: classNo,
    student_count: studentCount,
    role_id: roleId,
    refer_user_id: referUser,
    source: source,
    alias: alias,
  })
}

/**
 * 班主任已有班级，创建班级
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2227
 *
 * @param {string} [gradeId] [年级id]
 * @param {string} [classNo] [班级编号]
 * @param {int} [studentCount] [班级学生数量]
 * @param {int} [roleId] [角色类型]
 * @param {string} [source] [创建班级的来源,定义见下方来源]
 * @link [source来源定义] https://shimo.im/docs/C5D5xF9H5Kgn27xh
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function headTeacherCreateClass(gradeId, classNo, studentCount, roleId, source, alias, referUser) {
  return apiPost('/class/create_new', {
    grade_id: gradeId,
    class_no: classNo,
    student_count: studentCount,
    role_id: roleId,
    source: source,
    alias: alias,
    refer_user_id: referUser,
  })
}

/**
 * 获取班级基本信息
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1179
 * 
 * @param  {string} id [班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author vince
 */
export function getClassInfo(id) {
  return apiGet('/class/:id', {id})
}

/**
 * 获取公开班级信息
 * @link http://yapi.acagrid.com/project/29/interface/api/1281
 * 
 * @param  {[type]} id [description]
 * @return {[type]}    [description]
 */
export function getPublicClassInfo(id) {
  return apiGet('/class/name/:id', {id})
}

/**
 * 更新班级信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1193
 * 
 * @param  {string} id [班级id]
 * @param  {string} school_name [学校名称]
 * @param  {string} city_name [学校所在城市]
 * @param  {string} grade_id [年级id]
 * @param  {string} class_no [班级号]
 * @param  {string} student_count [班级人数]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function updateClassInfo(id,{school_name,alias,city_name,grade_id,class_no,student_count}) {
  return apiPut('/class/:id', {id,school_name,alias,city_name,grade_id,class_no,student_count})
}
/**
 * 更新班级信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1193
 * @param  {string} id [班级id]
 * @param  {0/1} join_verify [是否要验证]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function updateClassJoinVerify(id, join_verify) {
  return apiPut('/class/join_verify/:id', {id, join_verify})
}

/**
 * 获取加入班级表单的选项
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1151
 * 
 * @param  {string} id [班级id]
 * @return Promise
 *
 * @author vince
 */
export function getClassJoinOptions(id) {
  return apiGet('/class/join_option/:id', {id})
}

/**
 * 加入班级接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1153
 *
 * @param {string} [id] [班级id]
 * @param {object} [joinOptions] [加入班级的选项]
 *
 * role_id  角色id (班主任，任课教师，家委会，家长)
 * mobile   手机号码
 * code     验证码
 *
 * 教师需要数据
 * subject_id     科目id    选老师时必填
 * teacher_name     孩子名字         选家委会和家长时必填
 *
 * 家长或家委会需要数据
 * student_name     孩子名字         选家委会和家长时必填
 * sn       学号            选家委会和家长且班级有学号时必填(班级无学号机制的话，后台自动生成)
 * role_call_id   称谓id    选家委会和家长时必填
 *
 * @return Promise
 * @author vince
 * 
 */
export function joinClass(class_id, {role_id, mobile, code, subject_id, teacher_name, role_call_id, student_info, refer_user_id}) {
  return apiPost('/class/join', {class_id, role_id, mobile, code, role_call_id, teacher_name, subject_id, student_info, refer_user_id})
}

/**
 * 加入班级后获取通知二维码接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1229
 * 
 * @param  {string} post_id [信息post_id]
 * @param  {string} class_id [班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getNotificationQrcode(class_id, post_id) {
  return apiGet('/post/qrcode', {class_id, post_id})
}

/**
 * 邀请创办 - 获取临时创建班级关注二维码
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3693
 * 
 * @param  {string} id [临时班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getInviteClassQrcode(id) {
  return apiGet('/class/invite_classes/subscribe_qrcode', {id})
}

/**
 * 邀请创办 - 班主任确认临时班级接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3677
 * 
 * @param  {string} id [临时班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function confirmInviteClass(id) {
  return apiPut('/class/confirm_invite_class/:id', {id})
}
/**
 * 邀请创办 - 班主任拒绝临时班级接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3685
 * 
 * @param  {string} id [临时班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function rejectInviteClass(id) {
  return apiPut('/class/reject_invite_class/:id', {id})
}

/**
 * 获取当前用户所管理班级的学生列表
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1239
 * 
 * @return Promise
 * @author vince
 */
export function getClassStudents() {
  return apiGet('/class/student_lists')
}

/**
 * 获取学生列表信息，用于成员管理
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1275
 * 
 * @return Promise
 * @author Pandex
 */
export function getManageClassStudents(class_id) {
  return apiGet('/student/lists',{class_id})
}

/**
 * 获取老师列表信息，用于成员管理
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/
 * 
 * @return Promise
 * @author Pandex
 */
export function getManageClassTeachers(class_id) {
  return apiGet('/teacher/lists',{class_id})
}
/*
 * 移除老师接口
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/1261
 * @param {int} [id] [老师id]
 * @return Promise
 *
 * @author vince
 */
export function deleteClassTeacher(id, class_id) {
  return apiDelete('/class/teacher/:id', {id, class_id})
}

/*
 * 移除学生接口
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/1257
 * 
 * @param {int} id [学生id]
 * @return Promise
 *
 * @author Pandex
 */
export function deleteClassStudent(id, class_id) {
  return apiDelete('/class/student/:id', {id, class_id})
}

/*
 * 移除家长接口
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/1259
 * 
 * @param {int} id [家长id]
 * @return Promise
 *
 * @author Pandex
 */
export function deleteClassParent(id, class_id) {
  return apiDelete('/class/parent/:id', {id, class_id})
}
/**
 * 设置/取消家长为家委会成员
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/1265
 * 
 * @param {int} class_id  [班级id]
 * @param {int} parent_id [家长user_id]
 * @param {int} action    [1/0 1.设置 0.取消]
 *
 * @return promise
 * @author vince
 */
export function setParentCommittee(class_id, parent_id, action) {
  return apiPut('/class/parent_master',{class_id, parent_id, action})
}

/**
 * 获取家委会通知余额明细列表
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1283
 * 
 * @param  {string} class_id [班级id]
 * @return Promise
 *
 * @author Pandex
 */
export function getCommitteeCreditLists(class_id) {
  return apiGet('/parents/post_lists', {class_id})
}

/**
 * 加入班级入口是否还开放
 * 
 * @param  {[type]} class_id [description]
 * @return {[type]}          [description]
 */
export function isClassJoinOpen(class_id) {
  return apiGet('/class/:class_id/is_join_open', {class_id})
}

/**
 * 更新班级全局设置接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1618
 * 
 * @param  {string} field [字段]
 * @param {string} value [开关值]
 * @return Promise
 *
 * @author Pandex
 */
export function updateClassSetting(field,value) {
  return apiPut('/class/settings/:field', {field,value})
}

/**
 * 获取班级全局设置接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1610
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function getClassSetting() {
  return apiGet('/class/settings')
}

/**
 * 获取班级创建进程,如第一条帖子，是否绑群等
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1610
 * 
 * @return Promise
 *
 * @author vincent.row
 */
export function getClassCreateStatus(id) {
  return apiGet('/class/:id/create_status',{id})
}

/**
 * 获取班级小助手信息
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2179
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function getClassRobotInfo(class_id) {
  return apiGet('/class/robot/:class_id',{class_id})
}

/**
 * 批量修改学号
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2235
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function changeClassSN(class_id,class_sn) {
  return apiPut('/class/change_sn/:class_id',{class_id, class_id, class_sn})
}

/**
 * 获取班级信息收集人数
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2243
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function getInfoSubmitCount(class_id) {
  return apiGet('/class/:class_id/information_num',{class_id})
}

/**
 * 老师获取班级信息收集
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2251
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function getInfoSubmit(class_id,type) {
  return apiGet('/class/:class_id/information/:type/teacher',{class_id,type})
}


/**
 * 班主任解散班级
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2299
 *
 * @param {string} [class_id] [班级id]
 * @param {int} [mobile] [手机号]
 * @param {int} [code] [验证码]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function dissolveClass(class_id, mobile, code) {
  return apiPut('/class/:class_id/break', {class_id, mobile, code})
}

/**
 * 认领班主任
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/22
 *
 * @param {string} [class_id] [班级id]
 * @param {int} [mobile] [手机号]
 * @param {int} [code] [验证码]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function claimMasterTeacher(class_id, mobile, code) {
  return apiPost('/teacher/claim_teacher_admin', {class_id, mobile, code})
}

/**
 * 任课老师退出班级
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2291
 *
 * @param {string} [class_id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function teacherQuitClass(class_id) {
  return apiPut('/class/:class_id/quit', {class_id})
}

/**
 * 家委会退出班级
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2291
 *
 * @param {string} [id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function committeeQuitClass(id) {
  return apiPut('/class/:id/quit_parent_master', {id})
}

/**
 * 获取班级状态信息（班级是否解散）
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2307
 *
 * @param {string} [class_id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function getClassStatus(class_id) {
  return apiPut('/class/:class_id/check_info', {class_id})
}

/**
 * 获取用户单个班级所有学生列表接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2765
 * 
 * @param  {string} class_id [班级id]
 * @return Promise
 *
 * @author vince
 */
export function getClassStudentList(class_id, exclude_unjoined) {
  return apiGet('/class/all_students', {class_id, exclude_unjoined})
}

/**
 * 学生管理 - 获取分组信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3245
 * 
 * @param  {string} class_id [班级id]
 * @param  {string} id [分组id]
 * @return Promise
 *
 * @author Pandex
 */
export function getClassStudentGroupList(class_id, id) {
  return apiGet('/class/:class_id/student_groups/:id', {class_id, id})
}

/*
 * 将某位老师设为班主任接口
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/2781
 * 
 * @param {int} [teacher_id] [老师id]
 * @return Promise
 *
 * @author vince
 */
export function setClassHeadTeacher(teacher_id, class_id) {
  return apiPost('/class/set_teacher_master', {teacher_id, class_id})
}
/**
 * 更新班级统计设置
 * @link http://yapi.acagrid.com/project/29/interface/api/3117
 */
export function enableSummary(value) {
  return apiPut(`/class/settings/enable_summary`, {value})
}

/**
 * 点评 - 批量颁发奖状接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3181
 *
 * @param {string} [id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function postAwardCetrificates({id, content, authority_name, issuer_name, issue_time, template, students, honorary_title, image_url}) {
  return apiPost('/class/:id/certificates', {id, content, authority_name, issuer_name, issue_time, template, students, honorary_title, image_url})
}

/**
 * 外部点评 - 外部用户临时批量颁发奖状接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3749
 *
 * @param {string} [id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function postPCAwardCetrificates({content, authority_name, issuer_name, issue_time, template, students, honorary_title, image_url}) {
  return apiPost('/promote/instant_certificates', {content, authority_name, issuer_name, issue_time, template, students, honorary_title, image_url})
}
/**
 * 点评 - 获取奖状模板
 * @link http://yapi.acagrid.com/project/29/interface/api/3397
 */
export function getAwardCertificateTemplates() {
  return apiGet('/class/certificate_templates')
}

/**
 * 学生管理 - 创建学生分组
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/3213
 * 
 * @param  {string} id [班级id]
 * @param  {string} name [组名]
 * @param  {string} student_ids [学生id数组]
 * @return Promise
 *
 * @author Pandex
 */
export function createStudentsGroup(id, name, student_ids) {
  return apiPost('/class/:id/student_groups', {id, name, student_ids})
}
/**
 * 学生管理 - 更新学生分组
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/3229
 * 
 * @param {string} [class_id] [班级id]
 * @param  {string} id [分组id]
 * @param  {string} name [组名]
 * @param  {string} student_ids [学生id数组]
 * @return Promise
 *
 * @author Pandex
 */
export function updateStudentsGroup(class_id, id, name, student_ids) {
  return apiPut('/class/:class_id/student_groups/:id', {class_id, id, name, student_ids})
}
/**
 * 学生管理 - 更新学生分组
 * 
 * @link http://yapi.acagrid.com/project/29/interface/api/3237
 * 
 * @param {string} [class_id] [班级id]
 * @param  {string} id [分组id]
 * @return Promise
 *
 * @author Pandex
 */
export function deleteStudentsGroup(class_id, id) {
  return apiDelete('/class/:class_id/student_groups/:id', {class_id, id})
}
/**
 * 学生管理 - 获取班级分组列表接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3253
 *
 * @param {string} [class_id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function getClassGroup(class_id) {
  return apiGet('/class/:class_id/student_groups', {class_id})
}
/**
 * 点评 - 获取某次证书颁奖信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3189
 *
 * @param {string} [id] [班级id]
 * @param {string} [cert_id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function getCertificates(id, cert_id) {
  return apiGet('/class/:id/certificates/:cert_id', {id, cert_id})
}

/**
 * 外部点评 - 外部用户获取奖状列表接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3757
 *
 * @param {string} [id] [班级id]
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function getInstantCertificates(id) {
  return apiGet('/promote/instant_certificates/:id', {id})
}
/**
 * 邀请创办 - 获取家长/教师已创建临时班级列表接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3661
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function getInviteClasse() {
  return apiGet('/class/user_invite_classes')
}
/**
 * 邀请创办 - 根据ID获取临时创建班级信息
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3661
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function getInviteClassInfo(id) {
  return apiGet('/class/invite_classes/:id', {id})
}

/**
 * 学生管理 - 更新学生姓名
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3821
 * 
 * @return Promise
 * 
 * @author Pandex
 */
export function changeStudentName(student_id, student_name) {
  return apiPut('/class/change_student_name', {student_id, student_name})
}
/**
 * 申请加入 - 成员申请加入接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3933
 */
export function joinApplicant({class_id, role_id, subject_id, mobile, code, realname, teacher_name, role_call_id, student_info, refer_user_id}) {
  return apiPost('/class/join_applicants', {class_id, role_id, subject_id, mobile, code, realname, teacher_name, role_call_id, student_info, refer_user_id})
}
/**
 * 申请加入 - 获取临时关注二维码
 * @link http://yapi.acagrid.com/project/29/interface/api/3925
 */
export function getJoinApplicantQrcode(id) {
  return apiGet('/class/join_applicants/subscribe_qrcode', {id})
}
/**
 * 申请加入 - 获取成员加入申请信息接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3941
 */
export function getJoinApplicantInfo(id) {
  return apiGet(`/class/join_applicants/${id}`)
}
/**
 * 申请加入 - 同意成员申请加入接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3949
 */
export function approveJoinApplicant(id) {
  return apiPost(`/class/join_applicants/${id}/approve`)
}
/**
 * 申请加入 - 同意成员申请加入接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3949
 */
export function rejectJoinApplicant(id) {
  return apiPost(`/class/join_applicants/${id}/reject`)
}

/**
 * 新生入学 - 根据姓名查询学生所在班级
 * @link http://yapi.acagrid.com/project/29/interface/api/4085
 */
export function getQueryStudentClass(student_name, school_id, idcard_suffix) {
  return apiGet('/student/query_student_class', {student_name, school_id, idcard_suffix})
}
/**
 * 根据ID获取合作学校信息
 * @link http://yapi.acagrid.com/project/29/interface/api/4093
 */
export function getPartnerSchoolsInfo(id) {
  return apiGet('/partner_schools/:id', {id})
}

/**
 * 转让班主任 - 创建转让邀请
 * @link http://yapi.acagrid.com/project/29/interface/api/4245
 */
export function transformClassMaster(class_id, mobile, code) {
  return apiPost('/class/invite_class_masters', {class_id, mobile, code})
}

/**
 * 转让班主任 - 创建转让邀请
 * @link http://yapi.acagrid.com/project/29/interface/api/4245
 */
export function getTransformClassMasterInfo(id) {
  return apiGet('/class/invite_class_masters/:id', {id})
}

/**
 * 转让班主任 - 创建转让邀请
 * @link http://yapi.acagrid.com/project/29/interface/api/4245
 */
export function acceptTransformClassMaster(id) {
  return apiPut('/class/invite_class_masters/:id/accept', {id})
}


/**
 * 获取解散班级确认信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/6416
 * 
 * @param  {string} id [班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getClassDissolveInfo(id) {
  return apiGet('/class/:id/dismiss_confirm_info', {id})
}

/**
 * 转让班主任 - 获取关注二维码
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4269
 * 
 * @param  {string} id [临时班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getTransformClassQrcode(id) {
  return apiGet('/class/invite_class_masters/:id/subscribe_qrcode', {id})
}

/**
 * 创建班级邀请通知
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/3117
 * 
 * @param  {string} id [班级id]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function createInviteNotification(id) {
  return apiPost('/class/:id/invite_post', {id})
}



// WEBPACK FOOTER //
// ./src/api/classes.js